module.exports = __webpack_public_path__ + "img/logo.b0ef9af2.webp";